import React from 'react';
import { Button } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useNotify } from 'hooks';
import { clearEnvironment } from 'api';
import { ILoggedUserData } from 'types';
import { COLORS, DeleteDialog, SettingButtonText, useDialogControls } from 'components';

export const ClearEnvironmentButton = ({ loggedUserData }: { loggedUserData: ILoggedUserData }) => {
  const notify = useNotify();
  const deleteDialogControls: any = useDialogControls();

  const { mutateAsync: ClearEnvironment } = useMutation(clearEnvironment);

  const onDeleteClick = () => {
    ClearEnvironment()
      .then(() => {
        deleteDialogControls.close();
        notify.success(`${loggedUserData.tenant} environment is deleted!`);
      })
      .catch(() => {
        notify.error(
          `Some error has happen while deleting documents: ${loggedUserData.tenant}!`,
        );
      });
  };

  return (
    <>
      <Button
        onClick={deleteDialogControls.open}
        variant="contained"
        sx={{
          color: "white",
          backgroundColor: COLORS.Romance,
          width: "242px",
          height: "36px",
          borderRadius: '8px'
        }}
      >
        <SettingButtonText>Clear</SettingButtonText>
      </Button>
      <DeleteDialog
        isOpen={deleteDialogControls.isOpen}
        onCancel={deleteDialogControls.close}
        onDeleteClick={() => onDeleteClick()}
        selectedCount={undefined}
        target={`${loggedUserData.tenant} Environment`}
        title={
          `Delete ${loggedUserData.tenant} Environment?` as string
        }
      />
    </>
  )
}